import React, { useLayoutEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './ModelTelemetryLink.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { TELEMETRY_TYPES } from '../../constants/index';
import ModelTelemetryLink from './ModelTelemetryLink';

const ModelTelemetryLinkListTable = ({
  paginatedData = [],
  IsChangeAllowed,
  IsRemoveAllowed,
  ModelId,
  onRemoveClick,
  isOwner,
  setEditHandler,
  selectedId,
  disableMode,
  disableModeHandler,
  selectedModelCategoryId,
  telemetryLinkManager,
  intl
}) => {


  const fetchDataHandler = id => {
    setEditHandler(id);
    disableModeHandler(true);
  };

  const cancelHandler = () => {
    setEditHandler(-1);
    disableModeHandler(false);
  };
  useLayoutEffect(() => {
    if (disableMode) {
      const scrollPos = window.scrollY + window.innerHeight;
      window.scrollTo(0, scrollPos);
    }
  }, [disableMode]);
  const editModelContent = (
    <ModelTelemetryLink
      selectedModelCategoryId={selectedModelCategoryId}
      ModelId={ModelId}
      TelemetryLinkId={selectedId}
      cancelHandler={cancelHandler}
    />
  );

  let editorMain = (
    <tr>
      <td colSpan="12">{editModelContent}</td>
    </tr>
  );

  let newRowClass = telemetryLinkManager.showAddEditScreen && selectedId === 0 ? s.newRow : '';
  return (
    <div className={s.wsTableContainer}>
      <Table className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="model.telemetryLinks.position" defaultMessage="Position" />
            </th>

            <th>
              <FormattedMessage id="model.telemetryLinks.telemetryType" defaultMessage="Telemetry Type" />
            </th>
            <th>
              <FormattedMessage id="model.telemetryLinks.sourcePosition" defaultMessage="Source Position" />
            </th>
            <th>
              <FormattedMessage id="model.telemetryLinks.description" defaultMessage="Description" />
            </th>
            {isOwner && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.TelemetryLinkId}>
                <tr key={n.TelemetryLinkId} data-unittest="telemetryLinksData">
                  <td>{n.TargetComponentPositionName}</td>
                  <td>{TELEMETRY_TYPES[n.TelemetryType].name}</td>
                  <td>{n.SourceComponentPositionName}</td>
                  <td>{n.Description}</td>
                  {isOwner && <td className={s.btnCol}>
                    {IsChangeAllowed && (
                      <Button
                        variant="outline-secondary"
                        className={s.changeButton}
                        onClick={fetchDataHandler.bind(this, n.TelemetryLinkId)}
                        disabled={disableMode}
                        data-unittest="btnChange"
                      >
                        <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                      </Button>
                    )}
                    {IsRemoveAllowed && (
                      <Button
                        onClick={() => {
                          onRemoveClick(n.TelemetryLinkId);
                        }}
                        disabled={disableMode}
                        variant="outline-secondary"
                        className={s.changeButton}
                        data-unittest="removeData"
                      >
                        <FormattedMessage id="model.telemetryLinks.remove" defaultMessage="Remove" />
                      </Button>
                    )}


                  </td>
                  }
                </tr>
                {telemetryLinkManager.showAddEditScreen && selectedId === n.TelemetryLinkId && editorMain}
              </Fragment>
            );
          })}
        </tbody>
      </Table>
      <div >
        {telemetryLinkManager.showAddEditScreen && selectedId === 0 && editModelContent}
      </div>
    </div>
  );
};

ModelTelemetryLinkListTable.propTypes = {
  telemetryLinksData: PropTypes.array.isRequired,
  IsChangeAllowed: PropTypes.bool.isRequired
};

export default injectIntl(ModelTelemetryLinkListTable);
